<mat-card>
	<mat-card-content>
		<div class="col2">
			@if (title != null) {
<div
				class="innerRow1"
			
				><b>{{ title }}</b> ({{
					fixedPercentage != null ? fixedPercentage : getPercentageValue(percentageValue1, percentageValue2)
				}}%)</div
			>
}
			<div class="innerRow2">
				<div class="progress-bar-container">
					@if (lowerLimit != null) {
<div
						class="lower-limit"
					
						>{{ lowerLimit }}</div
					>
}
					<div class="progress-bar">
						<mat-progress-bar
							mode="buffer"
							[value]="
								fixedPercentage != null
									? fixedPercentage
									: getPercentageValue(percentageValue1, percentageValue2)
							"></mat-progress-bar>
					</div>
					@if (upperLimit != null) {
<div
						class="higher-limit"
					
						>{{ upperLimit }}</div
					>
}
				</div>
			</div>
		</div>
	</mat-card-content>
</mat-card>
